import { styled } from '@mui/material';

import { COLORS } from '~/styles/colors';

export const StyledHeader = styled('header')(() => {
  return {
    background: COLORS.grey100,
    borderBottom: `1px solid ${COLORS.grey150}`,
    position: 'relative',
    zIndex: 10,
  };
});

export const StyledHeaderContent = styled('div')(() => {
  return {
    display: 'flex',
    alignItems: 'stretch',
    justifyContent: 'space-between',
    minHeight: '65px',
  };
});

export const StyledLogoWrapper = styled('div')(() => {
  return {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    cursor: 'pointer',
  };
});

export const StyledLogo = styled('img')(() => {
  return {
    width: '136px',
  };
});
